const WORDS = [
  "Box para Banheiro", "Espelhos Sob Medida", "Vidro Temperado", "Guarda-corpo",
  "Fachada de Vidro", "Divisórias", "Portas de Vidro", "Manutenção",
];

export const Marquee = () => (
  <div className="relative overflow-hidden bg-[#012a60] py-6 border-y border-white/10">
    <div className="flex whitespace-nowrap animate-marquee">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-display text-2xl sm:text-3xl font-bold text-white/90">{w}</span>
          <span className="h-2 w-2 rounded-full bg-[#55c0e0]" />
        </span>
      ))}
    </div>
  </div>
);
